import BottomSheet, { BottomSheetBackdrop, BottomSheetView, useBottomSheetDynamicSnapPoints } from '@gorhom/bottom-sheet';
import { LayoutContext } from 'contexts/LayoutContext';
import { SxProp, View } from 'dripsy';
import { useCallback, useContext } from 'react';

interface UniBottomSheetProps {
  bottomSheetRef: React.RefObject<BottomSheet>;
  enableTouchThrough?: boolean;
  initialPointIndex?: number;
}

export const UniBottomSheet: React.FC<UniBottomSheetProps> = ({
  bottomSheetRef,
  enableTouchThrough = false,
  children,
  initialPointIndex
}) => {
  const layout = useContext(LayoutContext);
  const { animatedHandleHeight, animatedSnapPoints, animatedContentHeight, handleContentLayout } = useBottomSheetDynamicSnapPoints([
    'CONTENT_HEIGHT',
    'CONTENT_HEIGHT'
  ]);

  const renderBackdrop = useCallback(
    (props) => <BottomSheetBackdrop {...props} disappearsOnIndex={0} appearsOnIndex={1} pressBehavior={'none'} enableTouchThrough={true} />,
    []
  );

  return (
    <BottomSheet
      index={initialPointIndex ?? (layout.isMobile ? -1 : 0)}
      ref={bottomSheetRef}
      snapPoints={animatedSnapPoints}
      handleHeight={animatedHandleHeight}
      contentHeight={animatedContentHeight}
      backdropComponent={renderBackdrop}
      enablePanDownToClose
      handleComponent={() => <View sx={styles.bottomsheetHeadHandler} />}>
      <BottomSheetView onLayout={handleContentLayout}>{children}</BottomSheetView>
    </BottomSheet>
  );
};

enum StyleName {
  bottomsheetHeadHandler = 'bottomsheetHeadHandler'
}

const styles: Record<StyleName, SxProp> = {
  bottomsheetHeadHandler: {
    height: '$5',
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    backgroundColor: '$backgroundPrimary',
    borderWidth: 0
  }
};
